import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import ReviewWriteTemplate from '../../components/common/template/ReviewWriteTemplate';

import { ERROR_RETRY } from '../../lib/Error';
import * as api from '../../lib/api/api';
import * as PATH from '../../lib/routes/path';

class ReviewRewriteContainer extends Component {
  state = {
    itemName: '',
    createDateTime: '',
    rate: 5,
    storageRate: 5,
    communityUrl: '',
    blogUrl: '',
    instagramUrl: '',
    facebookUrl: '',
    text: '',
    images: [],
    previewImages: [],
    toMypage: false,
    storageUri: '',
    reviewImages: [],
    reviewImageIdsToDelete: '',
    reviewCatetoryType: '',
    isLoading: false,
  };

  componentDidMount() {
    this.handleGetDetailReview();
  }

  handleGetDetailReview = () => {
    const id = this.props.match.params.id;
    api.getDetailReview({ id }).then((response) => {
      this.setState({
        itemName: response.data.purchasedItemInfo.itemName,
        blogUrl: response.data.blogUrl,
        communityUrl: response.data.communityUrl,
        facebookUrl: response.data.facebookUrl,
        instagramUrl: response.data.instagramUrl,
        text: response.data.text,
        createDateTime: response.data.createDateTime,
        rate: response.data.star,
        storageRate: response.data.star,
        reviewImages:
          response.data.reviewImages.length > 5
            ? response.data.reviewImages.slice(0, 5)
            : response.data.reviewImages,
        storageUri:
          response.data.facetImage === null
            ? ''
            : response.data.facetImage.image.storageUri,
        reviewCategoryType: response.data.reviewCategory.name,
      });
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleMouseOver = (e) => {
    this.setState({
      rate: Number(e.target.id),
    });
  };

  handleMouseOut = () => {
    this.setState({
      rate: Number(this.state.storageRate),
    });
  };

  handleClick = (e) => {
    this.setState({
      storageRate: Number(e.target.id),
    });
  };

  handleAddImage = (e) => {
    if (
      this.state.images.length +
        this.state.reviewImages.length +
        e.target.files.length >
      5
    ) {
      alert('이미지는 최대 5장까지 올릴 수 있습니다.');
    } else {
      for (var i = 0; i < e.target.files.length; i++) {
        let reader = new FileReader();
        let file = e.target.files[i];
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.setState((prevState) => ({
            images: [...prevState.images, file],
            previewImages: [...prevState.previewImages, reader.result],
          }));
        };
      }
    }
  };

  handleDeleteImage = (id) => {
    const nextReviewImages = this.state.reviewImages.filter(
      (defaultImage) => defaultImage.id !== id,
    );
    this.setState({
      reviewImages: nextReviewImages,
      reviewImageIdsToDelete:
        this.state.reviewImageIdsToDelete === ''
          ? id
          : this.state.reviewImageIdsToDelete + ',' + id,
    });
  };

  handleDeleteAddImage = (index) => {
    const nextImages = this.state.images
      .slice(0, index)
      .concat(this.state.images.slice(index + 1, this.state.images.length));
    const nextPreviewImages = this.state.previewImages
      .slice(0, index)
      .concat(
        this.state.previewImages.slice(
          index + 1,
          this.state.previewImages.length,
        ),
      );
    this.setState({
      images: nextImages,
      previewImages: nextPreviewImages,
    });
  };

  handlePutReview = () => {
    const id = this.props.match.params.id;
    const {
      rate,
      text,
      reviewImageIdsToDelete,
      images,
      blogUrl,
      communityUrl,
      facebookUrl,
      instagramUrl,
      reviewImages,
    } = this.state;
    if (text.length > 20) {
      if (reviewImages.length + images.length >= 2) {
        this.setState({
          isLoading: true,
        });
        const fd = new FormData();
        for (var i = 0; i < images.length; i++) {
          fd.append('filesToUpload', images[i], images[i].name);
        }
        fd.append(
          'review',
          new Blob(
            [
              JSON.stringify({
                star: rate,
                text,
                blogUrl,
                communityUrl,
                facebookUrl,
                instagramUrl,
              }),
            ],
            {
              type: 'application/json',
            },
          ),
        );
        api
          .putReview({ id, reviewImageIdsToDelete, fd })
          .then((response) => {
            alert('수정이 완료되었습니다.');
            this.handleGetDetailReview();
            this.setState({
              toMypage: true,
            });
          })
          .catch((error) => {
            alert(ERROR_RETRY);
          })
          .finally(() =>
            this.setState({
              isLoading: false,
            }),
          );
      } else {
        alert('사진을 2장 이상 첨부해주세요.');
      }
    } else {
      alert('후기를 20자 이상 작성해주세요.');
    }
  };
  render() {
    const {
      itemName,
      createDateTime,
      rate,
      previewImages,
      communityUrl,
      blogUrl,
      instagramUrl,
      facebookUrl,
      text,
      reviewImages,
      storageUri,
      toMypage,
      isLoading,
      reviewCategoryType,
    } = this.state;
    const {
      handleMouseOut,
      handleMouseOver,
      handleClick,
      handleChange,
      handleAddImage,
      handleDeleteAddImage,
      handleDeleteImage,
      handlePutReview,
    } = this;
    return (
      <>
        {toMypage && <Redirect to={PATH.MYPAGE_REVIEW} />}
        <ReviewWriteTemplate
          rewrite
          thumbnail={storageUri === '' ? '' : storageUri}
          itemName={itemName}
          createDateTime={createDateTime}
          rate={rate}
          handleMouseOut={handleMouseOut}
          handleMouseOver={handleMouseOver}
          handleClick={handleClick}
          snsUrl={{ communityUrl, blogUrl, instagramUrl, facebookUrl }}
          onChange={handleChange}
          text={text}
          previewReviewImages={previewImages}
          defaultImages={reviewImages}
          reviewCategoryType={reviewCategoryType}
          handleAddImage={handleAddImage}
          handleDeleteAddImage={handleDeleteAddImage}
          handleDeleteDefaultImage={handleDeleteImage}
          handlePostReview={handlePutReview}
          loading={isLoading}
        />
      </>
    );
  }
}

export default ReviewRewriteContainer;
